import api from "./interceptor";

export const loginApi = async (userData) => {
    try {
        const response = await api.post(`auth/adminLogin`, userData);
        return response.data.data.token;
    } catch (e) {
        throw e.response.data;
    }
};